/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-29 16:28:04
 * @FilePath: \hlweb2.0\src\pages\Solution\Asset\ServiceValue\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Electronic() {
  const { t } = useTranslation();
  const serviceList = t("solution_asset.asset1", {
    returnObjects: true,
  });
  return (
    <div className="serviceValue_">
      <div className="serviceValue_con">
        {serviceList.map((item0, index0) => {
          return (
            <div className="serviceValue_li" key={index0}>
              <div className="serviceValue_li_til">{item0.num}</div>
              <div className="serviceValue_li_con">{item0.detail}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Electronic;
